import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { useIntl } from 'react-intl';
import { sentenceCase } from 'change-case';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';

import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import { withStyles } from '@material-ui/core';

import {
  TablePagination,
} from '../../../../components';

import { getI18n } from '../../../../utils/intl';

import {
  fetchProxies,
  fetchProxiesByApiKey,
  deployApiKeyToProxy,
  redeployApiKeyToProxy,
  undeployApiKeyFromProxy,
} from '../../../../actions/application';
import {
  getProxies,
  getProxiesByApiKey,
  getProxyErrors,
} from '../../../../reducers/application';
import {
  fetchDeploymentRefreshTime,
} from '../../../../actions/portalConfig';
import {
  getUserDetails,
  getDeploymentRefreshTime,
} from '../../../../reducers/portalConfig';
import {
  hasPublisherRole,
} from '../../../../utils';

import DeploymentCard from './DeploymentCard';

import {
  KEY_NAME_LABEL,
  STATUS_LABEL,
  KEY_STATUS_ENABLED,
  NO_RESULTS_TEXT,
} from '../labels';

import styles from './styles';

export const getDeploymentList = (deployments = [], apiKeyProxies = []) => {
  const combinedList = [];
  deployments.map((deployment) => {
    const matchedDeployment = apiKeyProxies.find(apiKeyDeployment =>
      apiKeyDeployment.proxyUuid === deployment.uuid);
    if (matchedDeployment) {
      combinedList.push(Object.assign({}, matchedDeployment, deployment));
    } else {
      combinedList.push(Object.assign({}, deployment));
    }
    return true;
  });
  return combinedList;
};

const SingleKeyView = (props) => {
  const {
    applicationUuid,
    apiKey,
    deploymentList = [],
    deploymentErrors,
    user,
    history,
    classes,
  } = props;
  return (
    <Fragment>
      {deploymentList.length > 0 ?
        deploymentList.map((obj, idx) => (
          <Box key={obj.uuid} width="25%" className={classes.deploymentCard}>
            <DeploymentCard
              index={idx}
              details={{
                applicationUuid,
                apiKey,
                uuid: obj.uuid,
                name: obj.name,
                type: obj.appDeploymentType,
                status: obj.status,
                statusMessage: obj.message,
                modifyTs: obj.lastTimeDeployed,
              }}
              errorObj={
                deploymentErrors.find(err =>
                  (err.proxyUuid === obj.uuid && err.apiKey === apiKey))
              }
              refreshTime={props.refreshTime}
              deployApiKey={props.deployApiKeyToProxy}
              redeployApiKey={props.redeployApiKeyToProxy}
              undeployApiKey={props.undeployApiKeyFromProxy}
              checkStatus={props.fetchProxiesByApiKey}
              user={user}
              history={history}
              classes={classes}
            />
          </Box>
        )) :
        <Box width="100%" className={classes.emptyResults}>
          {NO_RESULTS_TEXT}
        </Box>
      }
    </Fragment>
  );
};

SingleKeyView.propTypes = {
  applicationUuid: PropTypes.string,
  apiKey: PropTypes.string,
  deploymentList: PropTypes.arrayOf(PropTypes.shape({})),
  deploymentErrors: PropTypes.arrayOf(PropTypes.shape({})),
  fetchProxiesByApiKey: PropTypes.func,
  user: PropTypes.shape({}),
  history: PropTypes.shape({}),
  classes: PropTypes.shape({}),
};

const SingleRow = (props) => {
  const {
    applicationUuid,
    idx,
    row,
    deployments,
    classes,
  } = props;

  const onEditKeyButton = () => {
    localStorage.setItem('editKey', get(row, 'apiKey'));
    history.push(`/publish/applications/edit/${applicationUuid}/keys`);
  };

  const [open, setOpen] = useState(idx === 0);
  return (
    <Fragment>
      <TableRow onClick={() => setOpen(!open)}>
        <TableCell component="th" scope="row">
          {row.name}
          {get(row, 'defaultKey') &&
            <Chip
              className={classes.defaultChip}
              size="small"
              label={'Default'}
            />
          }
        </TableCell>
        <TableCell component="th" scope="row" align={'center'}>
          <Chip
            className={get(row, 'status') === KEY_STATUS_ENABLED
              ? classes.enabledChip
              : classes.disabledChip
            }
            size="small"
            label={sentenceCase(get(row, 'status'))}
          />
        </TableCell>
        <TableCell>
          {false &&
            <Button
              id={`edit-key-${idx}`}
              data-apim-test={`edit-key-btn-${idx}`}
              variant={'outlined'}
              className={classes.editKeyButton}
              onClick={() => onEditKeyButton()}
            >
              {'Edit Key'}
            </Button>
          }
        </TableCell>
        <TableCell>
          <IconButton
            className={classes.expandCollapseButton}
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <div style={{ padding: 8 }}>
              <SingleKeyView
                {...props}
                apiKey={get(row, 'apiKey')}
                deploymentList={getDeploymentList(deployments, get(row, 'proxies', []))}
              />
            </div>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

SingleRow.propTypes = {
  applicationUuid: PropTypes.string,
  idx: PropTypes.number,
  row: PropTypes.number,
  deployments: PropTypes.arrayOf(PropTypes.shape({})),
  classes: PropTypes.shape({}),
};

const GRID_ROWS_PER_PAGE_OPTIONS = [10, 20];
const GRID_ROWS_PER_PAGE_DEFAULT_OPTION = 10;

export const DeploymentsRaw = (props) => {
  const {
    applicationUuid,
    applicationDetails,
    fetchApplicationKeys,
    appKeys = [],
    appKeysTotalPages,
    appKeysTotalElements,
    isMultiKeySupport,
    deployments = [],
    apiKeyProxies = [],
    deploymentErrors = [],
    user,
    history,
    classes,
  } = props;
  const intl = getI18n(useIntl());
  const [isMultiKeyView, setIsMultiKeyView] = useState(false);
  const [deploymentList, setDeploymentList] = useState([]);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(GRID_ROWS_PER_PAGE_DEFAULT_OPTION);

  const onChangePage = (newPage) => {
    if (page === newPage) { return; }
    setPage(newPage);
    fetchApplicationKeys(applicationUuid, newPage, rowsPerPage);
  };
  const onChangePreviousPage = () => { onChangePage(page - 1); };
  const onChangeNextPage = () => { onChangePage(page + 1); };

  const onChangeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    fetchApplicationKeys(applicationUuid, 0, newRowsPerPage);
  };

  useEffect(() => {
    if (isMultiKeySupport && hasPublisherRole(user)) { // Multikey View
      props.fetchProxies();
      props.fetchDeploymentRefreshTime();
      appKeys.map(obj => {
        props.fetchProxiesByApiKey(obj.apiKey);
        return true;
      });
    } else {
      const apiKey = get(applicationDetails, 'apiKey');
      if (apiKey) {
        if (hasPublisherRole(user)) {
          props.fetchProxies();
          props.fetchDeploymentRefreshTime();
          props.fetchProxiesByApiKey(apiKey);
        }
      }
    }
  }, [applicationDetails, isMultiKeySupport]);

  useEffect(() => {
    if (appKeys.length > 0) {
      const tempArr = [];
      appKeys.map((obj) => {
        tempArr.push(Object.assign({},
          apiKeyProxies.find((o) => o.key === obj.apiKey),
          obj),
        );
        return true;
      });
      setRows(tempArr);
      setIsMultiKeyView(true);
    } else {
      const apiKey = get(applicationDetails, 'apiKey');
      const keyObject = apiKeyProxies.find(o => o.key === apiKey);
      setDeploymentList(getDeploymentList(deployments, get(keyObject, 'proxies', [])));
      setIsMultiKeyView(false);
    }
  }, [apiKeyProxies, appKeys.length, apiKeyProxies.length, deployments.length]);

  return (
    <div
      className={classes.appDeploymentsContainer}
      id="app-deployments-container" data-layer7-test="app-deployments-container"
    >
      {isMultiKeyView ?
        <Fragment>
          <TableContainer>
            <Table aria-label="collapsible table">
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell>{KEY_NAME_LABEL}</TableCell>
                  <TableCell align={'center'}>{STATUS_LABEL}</TableCell>
                  <TableCell />
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, idx) =>
                  <SingleRow key={idx} {...props} row={row} idx={idx} history={history} />)}
              </TableBody>
            </Table>
          </TableContainer>
          <div className={classes.paginationContainer}>
            <TablePagination
              id="app-deployments-keys-pagination"
              data-apim-test="app-deployments-keys-pagination"
              page={page}
              count={appKeysTotalElements}
              pageCount={appKeysTotalPages}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={GRID_ROWS_PER_PAGE_OPTIONS}
              onChangeRowsPerPage={onChangeRowsPerPage}
              onChangePage={onChangePage}
              onChangePreviousPage={onChangePreviousPage}
              onChangeNextPage={onChangeNextPage}
              labelRowsPerPage={intl.getI18nMessage('label.pagination.rows.per.page')}
            />
          </div>
        </Fragment> :
        <SingleKeyView
          {...props}
          applicationUuid={applicationUuid}
          apiKey={get(applicationDetails, 'apiKey')}
          deploymentErrors={deploymentErrors}
          deploymentList={deploymentList}
          history={history}
        />
      }
    </div>
  );
};

const mapStateToProps = state => ({
  user: getUserDetails(state),
  deployments: getProxies(state),
  apiKeyProxies: getProxiesByApiKey(state),
  deploymentErrors: getProxyErrors(state),
  refreshTime: getDeploymentRefreshTime(state),
});

const mapDispatchToProps = {
  fetchProxies,
  fetchProxiesByApiKey,
  fetchDeploymentRefreshTime,
  deployApiKeyToProxy,
  redeployApiKeyToProxy,
  undeployApiKeyFromProxy,
};

DeploymentsRaw.propTypes = {
  applicationUuid: PropTypes.string,
  applicationDetails: PropTypes.shape({}),
  fetchApplicationKeys: PropTypes.func,
  appKeys: PropTypes.arrayOf(PropTypes.shape({})),
  appKeysTotalPages: PropTypes.number,
  appKeysTotalElements: PropTypes.number,
  isMultiKeySupport: PropTypes.bool,
  deployments: PropTypes.arrayOf(PropTypes.shape({})),
  apiKeyProxies: PropTypes.arrayOf(PropTypes.shape({})),
  deploymentErrors: PropTypes.arrayOf(PropTypes.shape({})),
  history: PropTypes.shape({}),
  user: PropTypes.shape({}),
  classes: PropTypes.shape({}),
};
DeploymentsRaw.displayName = 'Deployments';

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(DeploymentsRaw);



// WEBPACK FOOTER //
// ./src/pages/Application/Details/Deployments/index.js